import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { VarianceReportByDueDatesResult, ReportFilter } from '../../../../models/analytics.model';
import { AnalyticsService } from '../../../../services/analytics.service';
import { LookupService } from '../../../../services/lookups/lookup.service';
import { LookupAdminService } from '../../../../services/lookups/lookupadmin.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { DropdownModule } from 'primeng/dropdown';
import { Table, TableModule } from 'primeng/table';
import { Observable } from 'rxjs/Observable';
import { NgForm } from '@angular/forms';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-report-variance-due-date',
  templateUrl: './report-variance-due-date.component.html',
  styleUrls: ['./report-variance-due-date.component.css']
})
export class ReportVarianceDueDateComponent implements OnInit {

loading: boolean;
cols: any[];


@ViewChild('dt') dt:Table;
@Input() reportFilters: ReportFilter;
reportData:VarianceReportByDueDatesResult[]=[];
  reportNames: SelectItem[];
  countries: SelectItem[];
  posts: SelectItem[];
  reportNumbers: SelectItem[];
  distributionTypes: SelectItem[];
  reportTypes:SelectItem[];
  programAreas:SelectItem[];
  reportCategories:SelectItem[];
  reportYears:SelectItem[];  
  dateSubmittedToWashingtons:SelectItem[];
  dueDates:SelectItem[];
  publishDates:SelectItem[]; 
  submittedDateVariances:SelectItem[];
  publishDateVariances:SelectItem[]; 
  types:SelectItem[]; 

  constructor(private analyticsService:AnalyticsService ,
   private lookupService: LookupService,private notifier:NotifierService) { }
  ngOnInit() {

    this.dt.filterConstraints['custom'] = (value, filter: any): boolean => {
       let found:number =0;
      if (filter === undefined || filter === null || filter === '') {
        return true;
      }

      if (value === undefined || value === null || !value.length) {
        return false;
      }
      filter.forEach(element => {
        if(value.indexOf(element)>-1)
           found=found+1;  
         
      });
      if(found>0)
       return true;
      else 
      return false;
      
    };
  }

 ngOnChanges(changes:SimpleChanges)
  {    
    if(!changes.firstChange)
    {
    this.LoadReportData();
    //this.makeRowsSameHeight();
    }

  }

  private LoadReportData()
  {
    console.log(this.reportFilters);
    this.analyticsService.getVarianceReportByDueDates$(this.reportFilters)
    .pipe(finalize(() => (this.loading = false)))
    .subscribe(resp=>{
      if(resp.ok)
      this.reportData = resp.body;
     
      for (let cnt = this.reportData.length - 1; cnt >= 0; cnt--) {           
        if (this.reportData[cnt].distributionType == "Public" ) {
        this.reportData[cnt].distributionType ="P";
        }
        else{ this.reportData[cnt].distributionType ="I";}
        
         if (this.reportData[cnt].reportType == "Required" ) {
        this.reportData[cnt].reportType ="R";
         }
        else{ this.reportData[cnt].reportType ="V";}            
        this.reportData[cnt].type = this.reportData[cnt].reportType + " | " + this.reportData[cnt].distributionType;
         }
      this.LoadTableFilters(this.reportData); 
      //this.makeRowsSameHeight();
      
    },
    error=>{
      this.notifier.notify('error','Error displaying report,please contact Tech Support');
      console.error('Error getting data via subscribe() method:', error);
    },
    ()=>{
      this.makeRowsSameHeight();
    }
    );
 
   this.cols = [
        { field: 'reportNumber', header: 'Report Year' },
        { field: 'reportName', header: 'Report Name' },
        { field: 'reportYear', header: 'Report Year' },
        { field: 'country', header: 'Country' },
        { field: 'post', header: 'Post' },        
        { field: 'reportCategory', header: 'Report Category' },        
        { field: 'type', header: 'Type' },
        { field: 'reportDueDate', header: 'Report DueDate' },
        { field: 'dateSubmittedToWashington', header: 'Date SubmittedToWashington' },
        { field: 'submittedDateVariance', header: 'Submitted DateVariance' },
        { field: 'publishedDate', header: 'Published Date' },
        { field: 'publishDateVariance', header: 'Publish DateVariance' }
      ];

  }

  filterTable(value:any,colName:string,matchMode:any)
  {
     this.dt.filter(value,colName,matchMode);
     this.makeRowsSameHeight();

  }
  makeRowsSameHeight() {
    setTimeout(() => {
        if (document.getElementsByClassName('ui-table-scrollable-wrapper').length) {
            let wrapper = document.getElementsByClassName('ui-table-scrollable-wrapper');
            for (var i = 0; i < wrapper.length; i++) {
               let w = wrapper.item(i) as HTMLElement;
               let frozen_rows: any = w.querySelectorAll('.ui-table-frozen-view tr');
               let unfrozen_rows: any = w.querySelectorAll('.ui-table-unfrozen-view tr');
               for (let i = 0; i < frozen_rows.length; i++) {
                  if (frozen_rows[i].clientHeight > unfrozen_rows[i].clientHeight) {
                     unfrozen_rows[i].style.height = frozen_rows[i].clientHeight+"px";
                     } 
                  else if (frozen_rows[i].clientHeight < unfrozen_rows[i].clientHeight) 
                  {
                     frozen_rows[i].style.height = unfrozen_rows[i].clientHeight+"px";
                  }
                }
              }
            }
     },300);
       }
  LoadTableFilters(reportData:VarianceReportByDueDatesResult[]) {
  this.reportNumbers = this.GetUniqueValues(reportData.map(r => r.reportNumber));
  this.reportNames = this.GetUniqueValues(reportData.map(r => r.reportName));
  this.reportYears = this.GetUniqueValues(reportData.map(r => r.reportYear));
  this.countries = this.GetUniqueValues(reportData.map(r => r.country)); 
  this.posts = this.GetUniqueValues(reportData.map(r => r.post));
  this.reportCategories = this.GetUniqueValuesWithComa(reportData.map(r => r.reportCategory));
  this.types = this.GetUniqueValues(reportData.map(r => r.type));   
  this.dueDates = this.dateSort(reportData.map(r => r.reportDueDate));  
  this.dateSubmittedToWashingtons = this.dateSort(reportData.map(r => r.dateSubmittedToWashington));
  this.submittedDateVariances = this.GetUniqueValues(reportData.map(r => r.submittedDateVariance));
  this.publishDates = this.dateSort(reportData.map(r => r.publishedDate));
  this.publishDateVariances = this.GetUniqueValues(reportData.map(r => r.publishDateVariance));  
  }
  dateSort(filterItem: any[]): SelectItem[]{
    var returnArray = new Array<SelectItem>();
      for (let i = 0; i < filterItem.length; i++) {
        if (returnArray.filter(r => r.label == filterItem[i]).length == 0)

          returnArray.push({ label: filterItem[i], value: filterItem[i] });
      }
      returnArray.sort((a, b) => new Date(b.value).getTime() - new Date(a.value).getTime());
      return returnArray;
  }

     GetUniqueValues(vals: any[]):SelectItem[] {
    var returnArry = new Array<SelectItem>();
    for (let cnt = 0; cnt < vals.length; cnt++) {
      if (returnArry.filter(r => r.label == vals[cnt]).length == 0)
        returnArry.push({ label: vals[cnt], value: vals[cnt] });
    }
      console.log(returnArry.length);
    returnArry.sort(
      (a, b): number => {
        if (a.value < b.value) return -1;
        if (a.value > b.value) return 1;
        return 0;
      }
    );
    return returnArry;
  }
  GetUniqueValuesWithComa(vals: any[]):SelectItem[] {
    var returnArry = new Array<SelectItem>();
    for (let cnt = 0; cnt < vals.length; cnt++) {          
      var splitVal=vals[cnt].split(',');
      for (let i = 0; i < splitVal.length; i++) { 
        if (returnArry.filter(r => r.label == splitVal[i]).length == 0)        
        returnArry.push({ label:splitVal[i], value:splitVal[i]});
      }
    }
      //console.log(returnArry.length);
    returnArry.sort(
      (a, b): number => {
        if (a.value < b.value) return -1;
        if (a.value > b.value) return 1;
        return 0;
      }
    );
    return returnArry;
  }
 
  onPage(first:number,rows:number)
  {
    this.makeRowsSameHeight();
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/reports-dashboard/custom-reports/report-variance-due-date/report-variance-due-date.component.ts